/**
 * Created by sban3308
 * */
import initialState from './initialState';
import {
  RECEIVE_EI_TERM_DETAILS, RESET_EI_TERM_DETAILS
} from '../actions/costImpactTermActions';

export default function costImpactTermDataReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.termDetails;
  }
  if (type === RECEIVE_EI_TERM_DETAILS) {
    return {
      ...state,
      items: data?.items || []
    };
  }
  if (type === RESET_EI_TERM_DETAILS) {
    return {
      ...state,
      items: []
    };
  }
  return state;
}
